import { gql } from '@apollo/client';

export const SEARCH_PRODUCTS_IN_PROVIDER = gql`
  query searchProductsInProvider($input: SearchProductsInProviderInput!) {
    searchProductsInProvider(input: $input) {
      searchSuggestions {
        name
        ric
        ticker
        exchange
        currency
        type
      }
    }
  }
`;
